/**
 * Content reference types
 * @module services/content-references/types
 */
import { List, Map, Set } from 'immutable'
import {
  CONTENT_TYPE_FAQ,
  CONTENT_TYPE_GUIDE,
  CONTENT_TYPE_GUIDE_DAY,
  CONTENT_TYPE_PERSON,
  CONTENT_TYPE_PROMOTION,
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_TAG,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_PRODUCT,
  CONTENT_TYPE_BONUS_PACKAGE,
  CONTENT_TYPE_SERVICE,
  CONTENT_TYPE_COURSE,
  CONTENT_TYPE_COURSE_MODULE,
  CONTENT_TYPE_CLIP,
} from '../content/content-types'

export const CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY = 'admin_category'
export const CONTENT_REFERENCE_TYPE_CATEGORY = 'category'
export const CONTENT_REFERENCE_TYPE_CENTERS = 'centers'
export const CONTENT_REFERENCE_TYPE_ARTICLE_CENTER = 'article-center'
export const CONTENT_REFERENCE_TYPE_MARKETING_CENTERS = 'marketing-centers'
export const CONTENT_REFERENCE_TYPE_CONSCIOUS_FORMAT = 'conscious-format'
export const CONTENT_REFERENCE_TYPE_CONSCIOUS_TOPIC = 'conscious-topic'
export const CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY = 'rainbow-category'
export const CONTENT_REFERENCE_TYPE_PRODUCT = 'product'
export const CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN = 'content_origin'
export const CONTENT_REFERENCE_TYPE_FILM_SUBJECT = 'film-subject'
export const CONTENT_REFERENCE_TYPE_FILM_TYPE = 'film-type'
export const CONTENT_REFERENCE_TYPE_FILTER_OPTIONS = 'filter_options'
export const CONTENT_REFERENCE_TYPE_FITNESS_DURATION = 'fitness-duration'
export const CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR = 'fitness-instructor'
export const CONTENT_REFERENCE_TYPE_FITNESS_LEVEL = 'fitness-level'
export const CONTENT_REFERENCE_TYPE_FITNESS_SPECIALTY = 'fitness-specialty'
export const CONTENT_REFERENCE_TYPE_FITNESS_STYLE = 'fitness-style'
export const CONTENT_REFERENCE_TYPE_GENRES = 'genres'
export const CONTENT_REFERENCE_TYPE_GUIDE = 'guide'
export const CONTENT_REFERENCE_TYPE_GUIDE_DAY_VIDEO = 'guide-day-video'
export const CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST = 'interview-guest'
export const CONTENT_REFERENCE_TYPE_INTERVIEW_HOST = 'interview-host'
export const CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS = 'meditation-focus'
export const CONTENT_REFERENCE_TYPE_MEDITATION_STYLE = 'meditation-style'
export const CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER = 'meditation-teacher'
export const CONTENT_REFERENCE_TYPE_MEDITATION_DURATION = 'meditation-duration'
export const CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES = 'onboarding_choices'
export const CONTENT_REFERENCE_TYPE_RECIPE_DIET = 'recipe-diet'
export const CONTENT_REFERENCE_TYPE_RECIPE_TYPE = 'recipe-type'
export const CONTENT_REFERENCE_TYPE_SERIES = 'series'
export const CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS = 'similar-videos'
export const CONTENT_REFERENCE_TYPE_SITE_SEGMENT = 'site_segment'
export const CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE = 'third-party-genre'
export const CONTENT_REFERENCE_TYPE_VIDEO_COLLECTION = 'video-collection'
export const CONTENT_REFERENCE_TYPE_VIDEO_TOPIC = 'video-topic'
export const CONTENT_REFERENCE_TYPE_YOGA_DURATION = 'yoga-duration'
export const CONTENT_REFERENCE_TYPE_YOGA_FOCUS = 'yoga-focus'
export const CONTENT_REFERENCE_TYPE_YOGA_LEVEL = 'yoga-level'
export const CONTENT_REFERENCE_TYPE_YOGA_STYLE = 'yoga-style'
export const CONTENT_REFERENCE_TYPE_YOGA_TEACHER = 'yoga-teacher'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_LEVEL = 'yi-yoga-level'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_TEACHER = 'yi-yoga-teacher'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_CLASS_STYLE = 'yi-yoga-class-style'
export const CONTENT_REFERENCE_TYPE_YI_USER_GOALS = 'yi-user-goals'
export const CONTENT_REFERENCE_TYPE_YI_COURSE_CATEGORY = 'yi-course-category'
export const CONTENT_REFERENCE_TYPE_YI_CHANNELS = 'yi-channels'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_FOCUS = 'yi-yoga-focus'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_DURATION = 'yi-yoga-duration'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_STYLE = 'yi-yoga-style'
export const CONTENT_REFERENCE_TYPE_YI_COURSE_MODULE = 'yi-course-module'
export const CONTENT_REFERENCE_TYPE_YI_COURSE_MODULE_TYPE = 'yi-course-module-type'
export const CONTENT_REFERENCE_TYPE_YI_CONTENT_TYPE = 'yi-content-type'
export const CONTENT_REFERENCE_TYPE_YI_ARTICLE_TOPIC = 'yi-article-topic'
export const CONTENT_REFERENCE_TYPE_YI_TAG = 'yi-tag'
export const CONTENT_REFERENCE_TYPE_YI_TAG_GROUP = 'yi-tag-group'
export const CONTENT_REFERENCE_TYPE_YI_CONSUMPTION_TYPE = 'yi-consumption-type'
export const CONTENT_REFERENCE_TYPE_YI_COURSE = 'yi-course'
export const CONTENT_REFERENCE_TYPE_YI_SERIES = 'yi-series'
export const CONTENT_REFERENCE_TYPE_YI_SERIES_EPISODE = 'yi-series-episode'
export const CONTENT_REFERENCE_TYPE_YI_YOGA_CLASS_SECONDARY_STYLE = 'yi-yoga-class-secondary-style'
export const CONTENT_REFERENCE_TYPE_YI_HOMEPAGE_HERO_CONTENT = 'yi-homepage-hero-content'
export const CONTENT_REFERENCE_TYPE_YI_PRACTICE_TYPE = 'yi-practice-type'
export const CONTENT_REFERENCE_TYPE_YI_PROMOTED_CONTENT = 'yi-promoted-content'
export const CONTENT_REFERENCE_TYPE_COURSE_MODULE = 'course-module'
export const CONTENT_REFERENCE_TYPE_COURSE_MODULE_PRACTICE = 'course-module-practice'
export const CONTENT_REFERENCE_TYPE_COURSE_MODULE_OTHER = 'course-module-other'
export const CONTENT_REFERENCE_TYPE_CLIP_VERT = 'clip-vert'
export const CONTENT_REFERENCE_TYPE_PRIMARY_COURSE = 'primary-course'
export const CONTENT_REFERENCE_TYPE_FULL_VIDEO = 'full-video'
export const CONTENT_REFERENCE_TYPE_FULL_SERIES = 'full-series'

/** CTA target refs for clip/video detail (dedicated section; not in taxonomy field maps). */
export const FULL_VIDEO_SERIES_REFERENCE_TYPES = [
  CONTENT_REFERENCE_TYPE_FULL_VIDEO,
  CONTENT_REFERENCE_TYPE_FULL_SERIES,
]

export const CONTENT_REFERENCE_TYPES = Set([
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_ARTICLE_CENTER,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_CONSCIOUS_FORMAT,
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_CONSCIOUS_TOPIC,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_FILM_SUBJECT,
  CONTENT_REFERENCE_TYPE_FILM_TYPE,
  CONTENT_REFERENCE_TYPE_FILTER_OPTIONS,
  CONTENT_REFERENCE_TYPE_FITNESS_DURATION,
  CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR,
  CONTENT_REFERENCE_TYPE_FITNESS_LEVEL,
  CONTENT_REFERENCE_TYPE_FITNESS_SPECIALTY,
  CONTENT_REFERENCE_TYPE_FITNESS_STYLE,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_GUIDE,
  CONTENT_REFERENCE_TYPE_GUIDE_DAY_VIDEO,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS,
  CONTENT_REFERENCE_TYPE_MEDITATION_STYLE,
  CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
  CONTENT_REFERENCE_TYPE_MEDITATION_DURATION,
  CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES,
  CONTENT_REFERENCE_TYPE_RECIPE_DIET,
  CONTENT_REFERENCE_TYPE_RECIPE_TYPE,
  CONTENT_REFERENCE_TYPE_SERIES,
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_SITE_SEGMENT,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  CONTENT_REFERENCE_TYPE_VIDEO_COLLECTION,
  CONTENT_REFERENCE_TYPE_VIDEO_TOPIC,
  CONTENT_REFERENCE_TYPE_YOGA_DURATION,
  CONTENT_REFERENCE_TYPE_YOGA_FOCUS,
  CONTENT_REFERENCE_TYPE_YOGA_LEVEL,
  CONTENT_REFERENCE_TYPE_YOGA_STYLE,
  CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
  CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
  CONTENT_REFERENCE_TYPE_FULL_VIDEO,
  CONTENT_REFERENCE_TYPE_FULL_SERIES,
])

export const CONTENT_REFERENCE_TYPE_CONTENT_TO_TYPES = Map({
  [CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_CATEGORY]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_CENTERS]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_ARTICLE_CENTER]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_MARKETING_CENTERS]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_CONSCIOUS_FORMAT]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_CONSCIOUS_TOPIC]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FILM_SUBJECT]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FILM_TYPE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FILTER_OPTIONS]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FITNESS_DURATION]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR]: CONTENT_TYPE_PERSON,
  [CONTENT_REFERENCE_TYPE_FITNESS_LEVEL]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FITNESS_SPECIALTY]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_FITNESS_STYLE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_GENRES]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_GUIDE]: CONTENT_TYPE_GUIDE,
  [CONTENT_REFERENCE_TYPE_GUIDE_DAY_VIDEO]: CONTENT_TYPE_VIDEO,
  [CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST]: CONTENT_TYPE_PERSON,
  [CONTENT_REFERENCE_TYPE_INTERVIEW_HOST]: CONTENT_TYPE_PERSON,
  [CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_MEDITATION_STYLE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER]: CONTENT_TYPE_PERSON,
  [CONTENT_REFERENCE_TYPE_MEDITATION_DURATION]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_RECIPE_DIET]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_RECIPE_TYPE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_SERIES]: CONTENT_TYPE_SERIES,
  [CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS]: CONTENT_TYPE_VIDEO,
  [CONTENT_REFERENCE_TYPE_SITE_SEGMENT]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_VIDEO_COLLECTION]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_VIDEO_TOPIC]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_YOGA_DURATION]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_YOGA_FOCUS]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_YOGA_LEVEL]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_YOGA_STYLE]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_YOGA_TEACHER]: CONTENT_TYPE_PERSON,
  [CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY]: CONTENT_TYPE_TAG,
  [CONTENT_REFERENCE_TYPE_PRODUCT]: CONTENT_TYPE_PRODUCT,
  [CONTENT_REFERENCE_TYPE_PRIMARY_COURSE]: CONTENT_TYPE_COURSE,
  [CONTENT_REFERENCE_TYPE_COURSE_MODULE_PRACTICE]: CONTENT_TYPE_COURSE_MODULE,
  [CONTENT_REFERENCE_TYPE_COURSE_MODULE_OTHER]: CONTENT_TYPE_COURSE_MODULE,
  [CONTENT_REFERENCE_TYPE_FULL_VIDEO]: CONTENT_TYPE_VIDEO,
  [CONTENT_REFERENCE_TYPE_FULL_SERIES]: CONTENT_TYPE_SERIES,
})

const baseReferenceFields = List([
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_CONSCIOUS_FORMAT,
  CONTENT_REFERENCE_TYPE_CONSCIOUS_TOPIC,
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_FILM_SUBJECT,
  CONTENT_REFERENCE_TYPE_FILM_TYPE,
  CONTENT_REFERENCE_TYPE_FITNESS_DURATION,
  CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR,
  CONTENT_REFERENCE_TYPE_FITNESS_LEVEL,
  CONTENT_REFERENCE_TYPE_FITNESS_SPECIALTY,
  CONTENT_REFERENCE_TYPE_FITNESS_STYLE,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS,
  CONTENT_REFERENCE_TYPE_MEDITATION_STYLE,
  CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
  CONTENT_REFERENCE_TYPE_MEDITATION_DURATION,
  CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES,
  CONTENT_REFERENCE_TYPE_RECIPE_DIET,
  CONTENT_REFERENCE_TYPE_RECIPE_TYPE,
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
  CONTENT_REFERENCE_TYPE_VIDEO_COLLECTION,
  CONTENT_REFERENCE_TYPE_VIDEO_TOPIC,
  CONTENT_REFERENCE_TYPE_YOGA_DURATION,
  CONTENT_REFERENCE_TYPE_YOGA_FOCUS,
  CONTENT_REFERENCE_TYPE_YOGA_LEVEL,
  CONTENT_REFERENCE_TYPE_YOGA_STYLE,
  CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_PRACTICE,
  CONTENT_REFERENCE_TYPE_COURSE_MODULE_OTHER,
])

/** Article content uses article-center instead of centers (Brooklyn reference type). */
const swapCentersForArticleCenter = (fields) =>
  fields.map((field) =>
    field === CONTENT_REFERENCE_TYPE_CENTERS ? CONTENT_REFERENCE_TYPE_ARTICLE_CENTER : field,
  )

const articleReferenceFields = swapCentersForArticleCenter(baseReferenceFields)

export const CONTENT_REFERENCE_FIELDS = Map({
  [CONTENT_TYPE_FAQ]: baseReferenceFields,
  [CONTENT_TYPE_PRODUCT]: baseReferenceFields,
  [CONTENT_TYPE_BONUS_PACKAGE]: baseReferenceFields,
  [CONTENT_TYPE_GUIDE]: baseReferenceFields,
  [CONTENT_TYPE_GUIDE_DAY]: baseReferenceFields,
  [CONTENT_TYPE_SERIES]: baseReferenceFields,
  [CONTENT_TYPE_PERSON]: baseReferenceFields,
  [CONTENT_TYPE_ARTICLE]: articleReferenceFields,
  [CONTENT_TYPE_PROMOTION]: baseReferenceFields,
  [CONTENT_TYPE_SERVICE]: baseReferenceFields,
  [CONTENT_TYPE_TAG]: baseReferenceFields,
  [CONTENT_TYPE_VIDEO]: baseReferenceFields.push(
    CONTENT_REFERENCE_TYPE_SERIES,
    CONTENT_REFERENCE_TYPE_PRIMARY_COURSE,
  ),
})

/** Main section fields in same order as baseReferenceFields (legacy uses that order when filtering to main). */
const baseReferenceFieldsMain = List([
  CONTENT_REFERENCE_TYPE_ADMIN_CATEGORY,
  CONTENT_REFERENCE_TYPE_CATEGORY,
  CONTENT_REFERENCE_TYPE_RAINBOW_CATEGORY,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_CONTENT_ORIGIN,
  CONTENT_REFERENCE_TYPE_GENRES,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_INTERVIEW_HOST,
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_THIRD_PARTY_GENRE,
])

const articleReferenceFieldsMain = swapCentersForArticleCenter(baseReferenceFieldsMain)

export const CONTENT_REFERENCE_FIELDS_MAIN = Map({
  [CONTENT_TYPE_FAQ]: baseReferenceFieldsMain,
  [CONTENT_TYPE_PRODUCT]: baseReferenceFieldsMain,
  [CONTENT_TYPE_BONUS_PACKAGE]: baseReferenceFieldsMain,
  [CONTENT_TYPE_GUIDE]: baseReferenceFieldsMain,
  [CONTENT_TYPE_GUIDE_DAY]: baseReferenceFieldsMain,
  [CONTENT_TYPE_SERIES]: baseReferenceFieldsMain,
  [CONTENT_TYPE_PERSON]: baseReferenceFieldsMain,
  [CONTENT_TYPE_ARTICLE]: articleReferenceFieldsMain,
  [CONTENT_TYPE_PROMOTION]: baseReferenceFieldsMain,
  [CONTENT_TYPE_SERVICE]: baseReferenceFieldsMain,
  [CONTENT_TYPE_TAG]: baseReferenceFieldsMain,
  [CONTENT_TYPE_CLIP]: baseReferenceFieldsMain,
  [CONTENT_TYPE_VIDEO]: baseReferenceFieldsMain.push(CONTENT_REFERENCE_TYPE_SERIES),
})

/** Explicit list of reference types for the "Content References Extended" section (full-width rows only). */
const videoExtendedReferenceFields = List([
  CONTENT_REFERENCE_TYPE_PRODUCT,
  CONTENT_REFERENCE_TYPE_FITNESS_DURATION,
  CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR,
  CONTENT_REFERENCE_TYPE_FITNESS_LEVEL,
  CONTENT_REFERENCE_TYPE_FITNESS_SPECIALTY,
  CONTENT_REFERENCE_TYPE_FITNESS_STYLE,
  CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES,
  CONTENT_REFERENCE_TYPE_VIDEO_COLLECTION,
])
export const CONTENT_REFERENCE_FIELDS_EXTENDED = Map({
  [CONTENT_TYPE_VIDEO]: videoExtendedReferenceFields,
  [CONTENT_TYPE_COURSE]: videoExtendedReferenceFields,
})

const baseReferenceFieldsAsync = List([
  CONTENT_REFERENCE_TYPE_SIMILAR_VIDEOS,
  CONTENT_REFERENCE_TYPE_CENTERS,
  CONTENT_REFERENCE_TYPE_MARKETING_CENTERS,
  CONTENT_REFERENCE_TYPE_INTERVIEW_GUEST,
  CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
  CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
  CONTENT_REFERENCE_TYPE_FITNESS_INSTRUCTOR,
  CONTENT_REFERENCE_TYPE_ONBOARDING_CHOICES,
  CONTENT_REFERENCE_TYPE_PRODUCT,
])

const articleReferenceFieldsAsync = swapCentersForArticleCenter(baseReferenceFieldsAsync)

export const CONTENT_REFERENCE_FIELDS_ASYNC = Map({
  [CONTENT_TYPE_FAQ]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_PRODUCT]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_BONUS_PACKAGE]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_GUIDE]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_GUIDE_DAY]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_SERIES]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_PERSON]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_ARTICLE]: articleReferenceFieldsAsync,
  [CONTENT_TYPE_PROMOTION]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_SERVICE]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_TAG]: baseReferenceFieldsAsync,
  [CONTENT_TYPE_VIDEO]: baseReferenceFieldsAsync.push(CONTENT_REFERENCE_TYPE_SERIES),
})

export const CONTENT_REFERENCE_TYPE_LABELS = Map({
  admin_category: '* Admin category (required)',
  category: 'Category',
  centers: 'Centers',
  'article-center': 'Article centers',
  'marketing-centers': 'Marketing centers',
  'conscious-format': 'Concious format',
  'conscious-topic': 'Concious topic',
  content_origin: '* Content origin (required)',
  'film-subject': 'Film Subject',
  'film-type': 'Film Type',
  'fitness-duration': 'Fitness duration',
  'fitness-instructor': 'Fitness instructor',
  'fitness-level': 'Fitness level',
  'fitness-specialty': 'Fitness specialty',
  'fitness-style': 'Fitness style',
  genres: 'Genres',
  guide: 'Guide',
  'guide-day-video': 'Guide day video',
  'interview-guest': 'Interview guest',
  'interview-host': 'Interview host',
  'meditation-focus': 'Meditation focus',
  'meditation-style': 'Meditation style',
  'meditation-teacher': 'Meditation teacher',
  'meditation-duration': 'Meditation duration',
  onboarding_choices: 'Onboarding choices',
  'recipe-diet': 'Recipe diet',
  'recipe-type': 'Recipe type',
  series: 'Series',
  'similar-videos': 'Similar videos',
  site_segment: 'Site segment',
  'third-party-genre': 'Third party genre',
  'video-collection': 'Video collection',
  'video-topic': 'Video topic',
  'yoga-duration': 'Yoga duration',
  'yoga-focus': 'Yoga focus',
  'yoga-level': 'Yoga level',
  'yoga-style': 'Yoga style',
  'yoga-teacher': 'Yoga teacher',
  'primary-course': 'Primary Course',
  'full-video': 'Full video',
  'full-series': 'Full series',
})

export const YOGA_REFERENCE_FIELDS = List([
  CONTENT_REFERENCE_TYPE_YOGA_DURATION,
  CONTENT_REFERENCE_TYPE_YOGA_FOCUS,
  CONTENT_REFERENCE_TYPE_YOGA_STYLE,
  CONTENT_REFERENCE_TYPE_YOGA_TEACHER,
  CONTENT_REFERENCE_TYPE_YOGA_LEVEL,
])

export const MEDITATION_REFERENCE_FIELDS = List([
  CONTENT_REFERENCE_TYPE_MEDITATION_DURATION,
  CONTENT_REFERENCE_TYPE_MEDITATION_FOCUS,
  CONTENT_REFERENCE_TYPE_MEDITATION_STYLE,
  CONTENT_REFERENCE_TYPE_MEDITATION_TEACHER,
])

export const CONTENT_REFERENCE_FIELDS_YORE = [
  CONTENT_REFERENCE_TYPE_CONSCIOUS_FORMAT,
  CONTENT_REFERENCE_TYPE_CONSCIOUS_TOPIC,
  CONTENT_REFERENCE_TYPE_FILM_SUBJECT,
  CONTENT_REFERENCE_TYPE_FILM_TYPE,
  CONTENT_REFERENCE_TYPE_RECIPE_DIET,
  CONTENT_REFERENCE_TYPE_RECIPE_TYPE,
  CONTENT_REFERENCE_TYPE_VIDEO_TOPIC,
]
